import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setState("failed");
      return;
    }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setState("paid");
          return;
        }
        if (["failed", "expired"].includes(r.data.payment_status)) {
          setState("failed");
          return;
        }
      } catch {
        // keep polling
      }
      if (attempts.current >= 10) {
        setState("timeout");
        return;
      }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center relative z-10">
      <div className="card p-10" data-testid="payment-result">
        {state === "checking" && (
          <>
            <Loader2 className="w-12 h-12 animate-spin text-cyan1 mx-auto mb-4" />
            <h1 className="font-heading text-2xl font-bold">Memverifikasi pembayaran...</h1>
            <p className="text-slate-500 text-sm mt-2">Jangan tutup halaman ini.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-green-400 mx-auto mb-4" />
            <h1 className="font-heading text-2xl font-bold">Pembayaran Berhasil!</h1>
            <p className="text-slate-400 text-sm mt-2">Langganan newsletter Anda sudah aktif. Selamat menikmati digest mingguan!</p>
            <Link to="/newsletter" className="btn-primary mt-6 inline-flex" data-testid="goto-newsletter">Buka Newsletter</Link>
          </>
        )}
        {(state === "failed" || state === "timeout") && (
          <>
            <XCircle className="w-14 h-14 text-red-400 mx-auto mb-4" />
            <h1 className="font-heading text-2xl font-bold">{state === "timeout" ? "Verifikasi Tertunda" : "Pembayaran Gagal"}</h1>
            <p className="text-slate-400 text-sm mt-2">
              {state === "timeout"
                ? "Status belum terkonfirmasi. Cek kembali di halaman newsletter dalam beberapa menit — jika sudah dibayar, langganan akan aktif otomatis."
                : "Transaksi tidak selesai. Silakan coba lagi."}
            </p>
            <Link to="/newsletter" className="btn-ghost mt-6 inline-flex">Kembali ke Newsletter</Link>
          </>
        )}
      </div>
    </div>
  );
}
